import * as L from "leaflet"
import {VectorLayerTMS} from "@/engine/layers/vectorLayerTMS.js";
import VectorTileLayer, {defaultFeatureLayer, featureLayerBase} from "@/engine/leaflet/VectorTileLayer.js";
import {geometryUtils} from "@/engine/helpers/geometryUtils.js";

/**
 *  the factory for Elevation Layer
 */
export class VectorLayerElevation extends VectorLayerTMS {
    constructor(struct) {
        struct.defaultStyle = {
            elevation: {
                "color": 'black',
                "opacity": 0.5,
                "weight": 1,
                "fill": false
            },
            elevationText: {
                "fill": "black",
                "font-weight": "bold",
                "opacity": 0.8,
                "font-size": 15, //in px (but px prefix should be omitted)
            }
        }

        struct.tmsStyleKey = "elevation"
        super(struct);

        this.styleKeys = {
            'elevation' : this.tmsLayerSetStyle.bind(this),
            'elevationText' : this.elevationTextSetStyle.bind(this)
        }

        this.textLabelsStyle = Object.assign( {}, this.getStyle("elevationText"))
        this.textLabelsStyle.class = "lineLabelsDecor";

        this.typeElevation = true // is used by mustache templates

        this.zProfile = {
            min: 0,
            max: 0,
            step: 0,
            dataField: ""
        };

        if (this.metadata && this.metadata.feature) {
            if (this.metadata.feature.z) {
                this.zProfile = this.metadata.feature.z
                if (! this.zProfile.dataField) {
                    // backup solution
                    // if there is no feature.z.dataField
                    // try to calc the data field name
                    // could be deleted later
                    for ( let a of this.metadata.feature.attributes) {
                        for (let n of [ 'z', 'elev', 'elevation' ]) {
                            if (a.name.toLowerCase() === n) {
                                this.zProfile.dataField = a.name
                            }
                        }
                    }
                }
            }
        }
        // zoom levels elevation value multiplier
        this.zlevm = {
            23: 5,
            22: 5,
            21: 5,
            20: 10,
            19: 10,
            18: 10,
            17: 10,
        }
        this.zlevmm = 16

        this.filter = function (feature, layer, zoom) {
            let elev = this.elevationValue(feature)
            if (elev === null)
                return false

            // shows only the lines with elevation multiples of multiplier
            let multiplier = 20
            if (zoom > this.zlevmm) {
                multiplier = this.zlevm[zoom]
                if (!multiplier) {
                    multiplier = 1
                }
            }
            if (Math.trunc(elev / multiplier) * multiplier === elev) {
                return true;
            }
            return false
        }.bind(this)

        this.textMinIndent = 30;
        this.minInscriptionsDisplayZoom = 16;
        let thisvl = this

        this.TMSLayerOptions.featureToLayer = function (feature, layerName, pxPerExtent, options) {
            // Construct a base feature layer.
            const self = featureLayerBase(feature, layerName, pxPerExtent, options);

            self.line = defaultFeatureLayer(
                feature,
                layerName,
                pxPerExtent,
                options
            );

            let text = null
            if (feature.properties !== undefined && this._map &&
                this._map.getZoom() >= thisvl.minInscriptionsDisplayZoom) {
                text = thisvl.elevationValue(feature)
            }

            self.line.graphics.id = 'pd-' + this._leaflet_id + '-' + feature._pbf.pos + '-' + feature.id + '-' + feature._geometry
            if (text !== null)
                self.textnode = geometryUtils.createTextNode(text, thisvl.textLabelsStyle, self.line.graphics, thisvl.textMinIndent)

            const group = L.SVG.create("g");
            group.appendChild(self.line.graphics);
            if (self.textnode) {
                group.appendChild(self.textnode);
            }

            //debug
            /*
            if (self.line.graphics.id.includes("-134-58")) {
                //console.log(`feature ${self.line.graphics.id} dx=${self.textnode.getAttribute('dx')}`)
                console.log(feature);
            }
             */
            //debug
            /*
            if (feature.id === 118) {
                self.interactionLine = VectorTileLayer.defaultFeatureLayer(
                    feature,
                    layerName,
                    pxPerExtent,
                    {color: 'green',
                        opacity: 1,
                        weight: 3}
                );
                self.interactionLine.setStyle({color: 'green',
                    opacity: 1,
                    weight: 3})
                group.appendChild(self.interactionLine.graphics);
                //options.color = "blue"
                console.log(feature)
            }
             */

            self.graphics = group;

            // Setting of style is delegated to the sub layers.
            self.setStyle = function setStyle(style) {
                self.line.setStyle(style);
            };

            // Initial setup of this feature layer.
            self.applyOptions(options);

            return self;
        }
        if (new.target === VectorLayerElevation) {
            this._fireNew();
        }
    }

    elevationValue(feature) {
        if (feature.properties === undefined ||
            this.zProfile.dataField === "") {
            return null
        }
        let elev = feature.properties[this.zProfile.dataField];
        if (elev === undefined) {
            return null
        }

        return elev
    }

    elevationTextSetStyle() {
        // todo implement.
        //  now edited text style is saved but is not applied without page reload
    }
}
